import Http from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    item: {
      Company_name: '',
      other_name: '',
      Address1: '',
      address2: '',
      address3: '',
      Telephone1: '',
      Telephone2: '',
      Telephone3: '',
      Telephone4: '',
      fax1: '',
      fax2: '',
      fax3: '',
      email1: '',
      Gst_regno: '',
      TaxCode: '',
      Tax: ''
    },
  },
  getters: {
    item: state => {
      return state.item
    },
  },
  mutations: {
    SET_ITEM(state, item){
      state.item = item
    }
  },
  actions: {

    show({ commit }){
      return new Promise((resolve, reject) => {
        Http.get(`company`).then(response => {
          commit('SET_ITEM', response.data)
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    update({ }, { payload } ){
      console.log(payload)
      return new Promise((resolve, reject) => {
        Http.put(`company`, payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },


  },
}
